
  import { defineComponent, PropType } from 'vue';

  import ComponentInput from '@/common/components/ComponentInput.vue';

  import RangeFieldLayout from './RangeFieldLayout.vue';
  import rangeFieldModel, { DEFAULT_RANGE_PLACEHOLDERS } from './rangeFieldModel';

  export default defineComponent({
    name: 'NumberRangeField',
    components: { ComponentInput, RangeFieldLayout },
    mixins: [rangeFieldModel],
    props: {
      placeholders: {
        type: Array as PropType<string[]>,
        default: () => DEFAULT_RANGE_PLACEHOLDERS,
      },
      maxLength: {
        type: Number,
        default: 500,
      },
    },
  });
